const setPerson = (state, person) => {
  state.person = person || null;
};

const setUser = (state, user) => {
  state.user = user || null;
};

export default {
  setPerson,
  setUser,
};
